import { render, staticRenderFns } from "./globalButton.vue?vue&type=template&id=0ba36376&scoped=true&"
import script from "./globalButton.vue?vue&type=script&lang=js&"
export * from "./globalButton.vue?vue&type=script&lang=js&"
import style0 from "./globalButton.vue?vue&type=style&index=0&id=0ba36376&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba36376",
  null
  
)

export default component.exports